export default __webpack_public_path__ + "static/media/Menu.6fa5af86.png";